import { ECurrency } from 'modules/payments/types';

export interface ISelectStablecoinOption {
  value: ECurrency;
  label: string;
}

export const STABLECOINS_OPTIONS: ISelectStablecoinOption[] = [
  {
    label: ECurrency.USDT,
    value: ECurrency.USDT,
  },
  {
    label: ECurrency.USDC,
    value: ECurrency.USDC,
  },
];

// If users make a payment in ANKR, they get 20% more requests
export const ANKR_PROMO_EXTRA_REQUESTS_RATE = 1.2;

// If users make a payment in a deal, they get 20% more requests
export const DEAL_PROMO_EXTRA_REQUESTS_RATE = 1.2;
